<template>
  <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      fullscreen
      scrollable
      max-width="290"
  >
    <v-card height="80%">
      <v-row class="ma-0" style="max-height: 50px;">
        <v-col cols="1">
          <v-btn small tile icon @click="$emit('close')">
            <v-icon color="primary">
              $chevronDown
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="7">
          <p class="text-truncate text-subtitle-1 font-weight-medium ma-0">Meus pedidos</p>
        </v-col>
      </v-row>

      <v-card-text>
        <v-card elevation="2" v-for="(request, index) in globalRequests.requests" :key="index" class="mb-3">
          <v-card-title class="primary--text justify-space-between" v-if="request.appName">
            <span class="text-subtitle-2 text-truncate" style="width: 80%" v-text="request.appName" />
            <v-avatar v-if="request.appLogo" width="40" height="40" min-width="40">
              <v-img :src="request.appLogo" alt="" />
            </v-avatar>
          </v-card-title>
          <v-card-subtitle class="pb-2 pl-2">
            <v-chip
                class="mx-1"
                x-small
                :color="colorStatus(request.status)"
                text-color="white"
            >
              {{ messageStatus(request.status) }}
            </v-chip>
          </v-card-subtitle>

          <v-list>
            <v-list-item
                v-for="product in requestProducts(request)"
                :key="product.id"
            >
              <v-list-item-avatar>
                <v-img
                    :src="product.image"
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title style="font-size: 0.9em">
                  {{product.amount}}x {{product.name}}
                </v-list-item-title>

                <v-list-item-subtitle style="font-size: 0.8em">
                  {{product.observation.join(', ')}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-card-actions>
            <p class="ma-0">Comanda {{request.cart.customer_service_code}}</p>
            <v-spacer></v-spacer>
            <p class="ma-0 primary--text font-weight-bold">{{formatMoney(request.cart.total_value)}}</p>
          </v-card-actions>

          <v-card-actions>
            <v-btn block
                   color="primary"
                   @click="requestReorder = request; openDialogConfirmationReorder = true">
              Refazer pedido
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card-text>

      <v-card>
        <v-card-text>
          <v-alert
              v-if="error"
              color="red"
              dark
              dismissible
          >{{error}}</v-alert>
        </v-card-text>
      </v-card>
    </v-card>

    <dialog-confirmation-reorder :dialog="openDialogConfirmationReorder"
                                 @close="openDialogConfirmationReorder = false"
                                 @confirm="reorder(requestReorder.cart)"
    />
  </v-dialog>
</template>

<script>
import {useGlobalCart, useGlobalRequests} from "../../../store/store";
import _ from "lodash";
import {initializeApp} from "@firebase/app";
import {getDatabase, onValue, ref, remove} from "@firebase/database";
import DialogConfirmationReorder from "./DialogConfirmationReorder.vue";

export default {
  name: "Requests",
  components: {
    DialogConfirmationReorder
  },
  props: {
    dialog: {
      required: true
    },
    error: {
      required: false,
      default: false
    }
  },

  data: () => ({
    requests: [],
    color: {
      0: 'red',
      1: 'green',
      2: 'orange',
    },
    requestReorder: null,
    openDialogConfirmationReorder: false
  }),
  setup () {
    const globalRequests = useGlobalRequests()
    const cart = useGlobalCart()

    return { globalRequests, cart }
  },
  created () {
    this.init ()
  },
  methods: {
    init () {
      this.requests = this.globalRequests.requests
      this.initFirebase()
    },
    initFirebase() {
      const dbRef = this.dbFirebase();

      onValue(dbRef, (snapshot) => {
        const data = snapshot.val();

        if (data) {
          Object.entries(data).forEach(item => {
            let request = this.requests.find(request => request.cart.unique_id === item[0])

            if (request) {
              //Tive que fazer isso porque a fila de exclusão da notificação no ERP às vezes demora mais que 1 minuto
              //e o Cloud Functions entra em ação, removendo o pedido e notificando o usuário que o pedido não foi
              //recebido pelo PDV.
              //Sabendo disso eu só atualizo o status do request se for igual 2 (Aguardando confirmação)
              //Essa situação só aconteceria se o usuário fizer o pedido e atualizar a tela
              if (request.status.status === 2) {
                request.status = {...item[1], status: item[1].error ? 0 : 1}
                this.$emit('request-confirmed')
              }

              this.removeObjectFirebase(item[0])
            }
          })
        }
      });
    },
    optionsGrouped (attributes) {
      return _.groupBy(attributes.options, 'id')
    },
    additionalsGrouped (additionals) {
      return _.groupBy(additionals, 'id')
    },
    colorStatus (status) {
      return status.error ? this.color[0] : this.color[status.status]
    },
    messageStatus (status) {
      return status.message
    },
    requestProducts (request) {
      return [...request.cart.products, ...request.cart.combos]
    },
    dbFirebase (uniqueId = null) {
      const firebaseConfig = _config.firebase_web_credentials

      const app = initializeApp(firebaseConfig)
      const database = getDatabase(app)
      const path =  [_config.firebase_status_path, uniqueId].filter(Boolean).join('/')

      return ref(database, path);
    },
    async removeObjectFirebase (uniqueId) {
      let dbRef = this.dbFirebase(uniqueId)
      await remove(dbRef).then(_ => {
        return true
      }).catch(_ => {
        return false
      })
    },

    reorder (cart) {
      this.cart.products = structuredClone(cart.products)
      this.cart.combos = structuredClone(cart.combos)

      let uniqueId = this.generateUuid()
      this.cart.unique_id = uniqueId
      this.cart.sale_start = this.dateFormat()

      this.requestReorder = null
      this.openDialogConfirmationReorder = false

      this.$emit('close')
      this.$emit('open-cart')
    }
  },
  computed: {
    totalCart () {
      return _.sumBy(this.requests, (item) => {
        return item.cart.total_value
      })
    }
  }
}
</script>

<style scoped>

</style>